export interface Category {
  name: string;
  slug: string;
  url: string;
  description: string;
  imageSeq: string;
}

export const categories: Category[] = [
  {
    name: 'Shoes',
    slug: 'shoes',
    url: 'https://kaspreadsheet.com/category-911-Shoes.html',
    description: 'Discover the latest sneaker and shoe finds curated in Sugargoo spreadsheet collections',
    imageSeq: 'cat-shoes-01',
  },
  {
    name: 'Hoodies & Sweaters',
    slug: 'hoodies-sweaters',
    url: 'https://kaspreadsheet.com/search-912/name/Shoes.html',
    description: 'Premium hoodies and sweaters from top Sugargoo spreadsheet selections',
    imageSeq: 'cat-hoodies-02',
  },
  {
    name: 'T-Shirts',
    slug: 't-shirts',
    url: 'https://kaspreadsheet.com/search-913/name/Shoes.html',
    description: 'Trending t-shirts and graphic tees organized in Sugargoo spreadsheets',
    imageSeq: 'cat-tshirts-03',
  },
  {
    name: 'Jackets',
    slug: 'jackets',
    url: 'https://kaspreadsheet.com/search-914/name/Shoes.html',
    description: 'Stylish jackets and outerwear compiled from Sugargoo spreadsheet databases',
    imageSeq: 'cat-jackets-04',
  },
  {
    name: 'Pants & Shorts',
    slug: 'pants-shorts',
    url: 'https://kaspreadsheet.com/search-915/name/Shoes.html',
    description: 'Quality pants and shorts sourced through Sugargoo spreadsheet recommendations',
    imageSeq: 'cat-pants-05',
  },
  {
    name: 'Headwear',
    slug: 'headwear',
    url: 'https://kaspreadsheet.com/search-916/name/Shoes.html',
    description: 'Caps, beanies and headwear accessories from Sugargoo spreadsheet finds',
    imageSeq: 'cat-headwear-06',
  },
  {
    name: 'Sets',
    slug: 'sets',
    url: 'https://kaspreadsheet.com/search-917/name/Shoes.html',
    description: 'Complete outfit sets and matching collections in Sugargoo spreadsheets',
    imageSeq: 'cat-sets-07',
  },
  {
    name: 'Underwear & Underpants',
    slug: 'underwear',
    url: 'https://kaspreadsheet.com/search-918/name/Shoes.html',
    description: 'Comfortable underwear options discovered through Sugargoo spreadsheet research',
    imageSeq: 'cat-underwear-08',
  },
  {
    name: 'Jersey',
    slug: 'jersey',
    url: 'https://kaspreadsheet.com/search-919/name/Shoes.html',
    description: 'Sports jerseys and athletic wear from Sugargoo spreadsheet collections',
    imageSeq: 'cat-jersey-09',
  },
  {
    name: 'Accessories',
    slug: 'accessories',
    url: 'https://kaspreadsheet.com/search-920/name/Shoes.html',
    description: 'Fashion accessories and essentials curated in Sugargoo spreadsheets',
    imageSeq: 'cat-accessories-10',
  },
  {
    name: 'Bags',
    slug: 'bags',
    url: 'https://kaspreadsheet.com/search-921/name/Shoes.html',
    description: 'Trendy bags and backpacks from Sugargoo spreadsheet recommendations',
    imageSeq: 'cat-bags-11',
  },
  {
    name: 'Belts',
    slug: 'belts',
    url: 'https://kaspreadsheet.com/search-922/name/Shoes.html',
    description: 'Designer belts and accessories found in Sugargoo spreadsheet databases',
    imageSeq: 'cat-belts-12',
  },
  {
    name: 'Perfumes',
    slug: 'perfumes',
    url: 'https://kaspreadsheet.com/search-923/name/Shoes.html',
    description: 'Fragrances and perfumes discovered through Sugargoo spreadsheet resources',
    imageSeq: 'cat-perfumes-13',
  },
  {
    name: 'Other Stuff',
    slug: 'other-stuff',
    url: 'https://kaspreadsheet.com/search-924/name/Shoes.html',
    description: 'Miscellaneous unique finds and hidden gems from Sugargoo spreadsheets',
    imageSeq: 'cat-other-14',
  },
];